/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventDTO } from './EventDTO';
import {
    EventDTOFromJSON,
    EventDTOFromJSONTyped,
    EventDTOToJSON,
} from './EventDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface EventDTOPage
 */
export interface EventDTOPage {
    /**
     * 
     * @type {Array<EventDTO>}
     * @memberof EventDTOPage
     */
    content?: Array<EventDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof EventDTOPage
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventDTOPage
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EventDTOPage
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof EventDTOPage
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof EventDTOPage
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof EventDTOPage
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof EventDTOPage
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof EventDTOPage
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof EventDTOPage
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the EventDTOPage interface.
 */
export function instanceOfEventDTOPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventDTOPageFromJSON(json: any): EventDTOPage {
    return EventDTOPageFromJSONTyped(json, false);
}

export function EventDTOPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventDTOPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(EventDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function EventDTOPageToJSON(value?: EventDTOPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(EventDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

